import Vue from 'vue';
import devices from '@/plugins/devices';
import features from '@/plugins/features';
import authData from '@/plugins/authData';
import formatting from '@/plugins/formatting';
import permissions from '@/modules/staff/utils/permissions';
import ValidationPlugin from '@/plugins/validations/validationsPlugin';
import TextEditor from './tinymce/tinymceInstant';

import '@/plugins/sentry';
import '@/plugins/vuetify';

devices.addToVueInstance(Vue);
features.addToVueInstance(Vue);
authData.addToVueInstance(Vue);
formatting.addToVueInstance(Vue);
permissions.addToVueInstance(Vue);
Vue.use(ValidationPlugin);

Vue.component('TextEditor', TextEditor);
